import { environment } from '@src/utils/environment'
import axios from 'axios'

axios.defaults.baseURL = environment.API_ROOT
axios.defaults.withCredentials = false
